import { types } from 'mobx-state-tree';

import { HiringTeamsStore, CareerPageStore, EmailTemplatesStore, TagsPageStore } from '@src/features/preferences';

export const CompanyPreferencesStore = types.model({
  emailTemplates: types.optional(EmailTemplatesStore, {}),
  hiringTeams: types.optional(HiringTeamsStore, {}),
  careerPage: types.optional(CareerPageStore, {}),
  tagsPage: types.optional(TagsPageStore, {})
});
